import { GET_COUNTRIES } from "../types";

const initialState = {
  countries: [],
};

const countries = (state = initialState, action) => {
  switch (action.type) {
    case GET_COUNTRIES:
      return {
        ...state,
        countries: action.countries,
      };
    default:
      return state;
  }
};

export default countries;
